module.exports = __webpack_public_path__ + "img/prijava-vizual-1920.bdc2d535.png";